import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=guest, obj=authed

  useEffect(() => {
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.mfa_required) return data;
    setUser(data);
    return data;
  };

  const verifyMfa = async (mfa_token, code) => {
    const { data } = await api.post("/auth/mfa/verify", { mfa_token, code });
    setUser(data);
    return data;
  };

  const enterDemo = async (email) => {
    const { data } = await api.post("/demo/enter", { email });
    setUser(data);
    return data;
  };

  const register = async (payload) => {
    const session_id = localStorage.getItem("rp_sid") || "";
    const { data } = await api.post("/auth/register", { ...payload, session_id });
    const variant = localStorage.getItem("rp_ab_hero");
    if (variant) {
      api.post("/public/analytics/event", {
        event: "ab_conversion", session_id,
        meta: { experiment: "hero_headline", variant },
      }).catch(() => {});
    }
    setUser(data);
    return data;
  };

  const logout = async () => {
    await api.post("/auth/logout");
    setUser(false);
  };

  const refreshUser = async () => {
    const { data } = await api.get("/auth/me");
    setUser(data);
    return data;
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, verifyMfa, enterDemo, register, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
